export default __webpack_public_path__ + "static/media/MercadoPago.a32d1c54.png";